import { gql } from 'apollo-angular';

export const LEADS = gql`
  query leads($search: String, $status: [LeadStatus!]) {
    leads(search: $search, status: $status) {
      id
      branchID
      assignedTo
      assignedToData {
        id
        firstName
        lastName
      }
      leadName
      email
      phone
      source
      status
      industry
      companyName
      expectedValue
      expectedCloseDate
      notes
      probability
      createdAt
      updatedAt
    }
  }
`;

export const FIND_ALL_LEADS_PAGINATION = gql`
  query findAllLeadsWithPagination($input: LeadPaginationInput, $status: [LeadStatus!]) {
    findAllLeadsWithPagination(input: $input, status: $status) {
      leads {
      id
      branchID
      assignedTo
      assignedToData{
        firstName
        lastName
      }
      leadName
      email
      phone
      source
      status
      industry
      companyName
      expectedValue
      expectedCloseDate
      notes
      probability
      createdAt
      updatedAt
    }
    total
    skip
    limit
    }
  }
`;

export const LEAD = gql`
  query lead($id: Int!) {
    lead(id: $id) {
      id
      branchID
      assignedTo
      assignedToData {
        id
        firstName
        lastName
      }
      leadName
      email
      phone
      source
      status
      industry
      companyName
      expectedValue
      expectedCloseDate
      notes
      customerId
      probability
      createdAt
      updatedAt
    }
  }
`;

export const NOTES = gql`
  query notes($leadId: Float!, $search: String) {
    notes(leadId: $leadId,search: $search) {
      id
      leadId
      content
      createdBy
      createdByData {
        id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
`;

export const ACTIVITIES = gql`
  query activities($leadId: Float!, $search: String) {
    activities(leadId: $leadId,search: $search) {
      id
      leadId
      leadData {
        id
        leadName
      }
      employeeId
      employeeData {
        id
        firstName
        lastName
      }
      type
      time
      details
      outcome
      createdAt
      updatedAt
    }
  }
`;
